import React, { Fragment } from 'react';
import cn from 'classnames';
import Button from '../../elements/Button/Button';
import Checkbox from '../../elements/Checkbox/Checkbox';
import ListItem from '../../elements/List/ListItem';
import Routes from '../../components/Routes';
import api from '../../api';
import { showError } from '../../elements/Toasts/toastActions';
import { Link } from 'react-router-dom';
import popup from './Popup.module.scss';
import { ReactComponent as LoginLogoIcon } from '../../styles/images/logo-login.svg';
import { ReactComponent as ArrowBack } from '../../styles/icon/arrow-back.svg';
import { logout, setAuthSuccess } from '../../components/auth/redux/authActions';
import strings from '../../lang/lang';
import LoginHeader from './LoginHeader';
import {keycloak} from "../../keycloak-config";
import ThemeWatcher from "../../components/ThemeWatcher";

export default function TermOfUsePage(props: any) {
  const [agreed, setAgreed] = React.useState(false);

  const agreeToTerms = async () => {
    try {
      const saveTermAgreement = await api.portal.saveTermAgreement();
      const respStatus = saveTermAgreement.status;
      if (401 === respStatus) {
        props.history.push(Routes.routes.ROOT.path);
        await logout();
      } else if (respStatus === 200) {
        setAuthSuccess();
        props.history.push(Routes.routes.ROOT.path);
      } else {
        throw new Error('Error in saving term agreement');
      }
    } catch (e) {
      console.log('error', e);
      showError(strings.termOfUsePage.errors.savingTermAgreement);
    }
  };

  return (
    <div className={popup.popup}>
      <ThemeWatcher />
      <LoginHeader showSignUp={false} />
      <div className={popup.popup__hold}>
        <Link to={Routes.routes.ROOT.path}>
          <Button
            name={strings.termOfUsePage.buttons.back}
            variant="back"
            secondaryClassName="terms"
          >
            <ArrowBack />
          </Button>
        </Link>
        <div className={popup.popup__wrap}>
          <div className={cn(popup.popup__box, popup['popup__box--lg'])}>
            <Link to={Routes.routes.ROOT.path} className={popup.popup__logo}>
              <LoginLogoIcon />
            </Link>
            <div className={cn(popup.popup__container, popup['popup__container--terms'])}>
              <div className={popup.popup__terms}>
                <h2>
                  {strings.formatString(
                    strings.termOfUsePage.text.title,
                    <strong>"Terms of Use"</strong>
                  )}
                </h2>
                <div>
                  <ol className={popup.popup__list_number}>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.p1Title}</strong>
                      </p>
                      <p>
                        {strings.formatString(
                          strings.termOfUsePage.text.p1,
                          <a href="https://developer.staq.io">
                            {strings.termOfUsePage.text.p1_0}
                          </a>,
                          <strong>{strings.termOfUsePage.text.p1_1}</strong>,
                          <i>{strings.termOfUsePage.text.p1_2}</i>,
                          <i>{strings.termOfUsePage.text.p1_3}</i>
                        )}
                      </p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p11,
                              <a href="https://staq.io/privacy-policy">
                                {strings.termOfUsePage.text.p11_0}
                              </a>
                            )}
                          </p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p12}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p13}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p14}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p15}</p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.p2Title}</strong>
                      </p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>{strings.termOfUsePage.text.p21}</p>
                        </li>
                      </ol>
                    </li>
                    <li className={popup.popup__list_none}>
                      <ol className={popup.popup__list_letter}>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p21_a,
                              <strong>{strings.termOfUsePage.text.p21_a_0}</strong>
                            )}
                          </p>
                        </li>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p21_b,
                              <strong>{strings.termOfUsePage.text.p21_b_0}</strong>
                            )}
                          </p>

                          <ol className={popup.popup__list_roman}>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_b_i}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_b_ii}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_b_iii}</p>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p21_c,
                              <strong>{strings.termOfUsePage.text.p21_c_0}</strong>
                            )}
                          </p>
                        </li>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p21_d,
                              <strong>{strings.termOfUsePage.text.p21_d_0}</strong>
                            )}
                          </p>
                        </li>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p21_e,
                              <strong>{strings.termOfUsePage.text.p21_e_0}</strong>
                            )}
                          </p>
                          <ul>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_e_p1}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_e_p2}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_e_p3}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_e_p4}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_e_p5}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_e_p6}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_e_p7}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p21_e_p8}</p>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p21_f,
                              <strong>{strings.termOfUsePage.text.p21_f_0}</strong>
                            )}
                          </p>
                        </li>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p21_g,
                              <strong>{strings.termOfUsePage.text.p21_g_0}</strong>
                            )}
                          </p>
                        </li>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p21_h,
                              <strong>{strings.termOfUsePage.text.p21_h_0}</strong>
                            )}
                          </p>
                        </li>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p21_i,
                              <strong>{strings.termOfUsePage.text.p21_i_0}</strong>
                            )}
                          </p>
                        </li>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p21_j,
                              <strong>{strings.termOfUsePage.text.p21_j_0}</strong>
                            )}
                          </p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p21_k}</p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.p3Title}</strong>
                      </p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>{strings.termOfUsePage.text.p31}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p32}</p>
                          <ol className={popup.popup__list_number}>
                            <li>
                              <p>{strings.termOfUsePage.text.p321}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p322}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p323}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p324}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p325}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p326}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p327}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p328}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p329}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p3210}</p>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p33}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p34}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p35}</p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.p4Title}</strong>
                      </p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>{strings.termOfUsePage.text.p41}</p>
                          <ol className={popup.popup__list_number}>
                            <li>
                              <p>
                                {strings.formatString(
                                  strings.termOfUsePage.text.p411,
                                  <strong>{strings.termOfUsePage.text.p411_0}</strong>
                                )}
                              </p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p412}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p413}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p414}</p>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>{strings.termOfUsePage.text.p5}</p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>{strings.termOfUsePage.text.p51}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p52}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p53}</p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.p6Title}</strong>
                      </p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>{strings.termOfUsePage.text.p61}</p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.p7Title}</strong>
                      </p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>{strings.termOfUsePage.text.p71}</p>
                          <ol className={popup.popup__list_number}>
                            <li>
                              <p>{strings.termOfUsePage.text.p711}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p712}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p713}</p>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.p8Title}</strong>
                      </p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>{strings.termOfUsePage.text.p81}</p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.p9Title}</strong>
                      </p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>{strings.termOfUsePage.text.p91}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p92}</p>
                          <ol className={popup.popup__list_number}>
                            <li>
                              <p>{strings.termOfUsePage.text.p921}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p922}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p923}</p>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p93}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p94}</p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.p10Title}</strong>
                      </p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>{strings.termOfUsePage.text.p_11}</p>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p_12}</p>
                        </li>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p_13,
                              <strong>{strings.termOfUsePage.text.p_13_0}</strong>
                            )}
                          </p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.p14Title}</strong>
                      </p>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>
                            {strings.formatString(
                              strings.termOfUsePage.text.p141,
                              <strong>{strings.termOfUsePage.text.p141_0}</strong>
                            )}
                          </p>
                          <ol
                            className={cn(
                              popup.popup__list_roman,
                              popup['popup__list_roman--left']
                            )}
                          >
                            <li>
                              <p>{strings.termOfUsePage.text.p141_i}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p141_ii}</p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p141_iii}</p>
                            </li>
                            <li>
                              <p>
                                {strings.formatString(
                                  strings.termOfUsePage.text.p141_iv,
                                  <a href="https://owasp.org/www-project-top-ten/">
                                    {strings.termOfUsePage.text.p141_iv_0}
                                  </a>
                                )}
                              </p>
                            </li>
                            <li>
                              <p>{strings.termOfUsePage.text.p141_v}</p>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <p>{strings.termOfUsePage.text.p142}</p>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <div className={popup.popup__title_text}>
                        {/* <strong>{strings.termOfUsePage.text.pLastTitle}</strong> */}
                        <p>
                          <strong>{strings.termOfUsePage.text.pLastTitle}</strong>
                        </p>
                      </div>
                      <ol className={popup.popup__list_number}>
                        <li>
                          <p>
                            <i>{strings.termOfUsePage.text.pWithCause}</i>
                          </p>
                          <div className={popup.popup__general}>
                            <div>
                              <span>l.</span> <p>{strings.termOfUsePage.text.pWithCause_l}</p>
                            </div>
                            <div className={popup.popup__roman}>
                              <div>
                                <span>i</span> <p>{strings.termOfUsePage.text.pWithCause_l_i}</p>
                              </div>
                              <div>
                                <span>ii</span> <p>{strings.termOfUsePage.text.pWithCause_l_ii}</p>
                              </div>
                              <div>
                                {' '}
                                <span>iii</span>{' '}
                                <p>{strings.termOfUsePage.text.pWithCause_l_iii}</p>{' '}
                              </div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className={popup.popup__general}>
                            <p>
                              <i>{strings.termOfUsePage.text.pWithoutCause}</i>
                            </p>
                            <div>
                              <span>m.</span> <p>{strings.termOfUsePage.text.pWithoutCause_m}</p>
                            </div>
                          </div>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>
                        <strong>{strings.termOfUsePage.text.pWithoutCause_general}</strong>
                      </p>
                    </li>
                  </ol>

                  <div className={popup.popup__general}>
                    <div>
                      <span>a.</span>{' '}
                      <p>
                        {strings.formatString(
                          strings.termOfUsePage.text.pWithoutCause_n,
                          <strong>{strings.termOfUsePage.text.pWithoutCause_n_0}</strong>
                        )}
                      </p>
                    </div>
                    <div>
                      <span>b.</span>{' '}
                      <p>
                        {strings.formatString(
                          strings.termOfUsePage.text.pWithoutCause_o,
                          <strong>{strings.termOfUsePage.text.pWithoutCause_o_0}</strong>
                        )}
                      </p>
                    </div>
                    <div>
                      <span>c.</span>{' '}
                      <p>
                        {strings.formatString(
                          strings.termOfUsePage.text.pWithoutCause_p,
                          <strong>{strings.termOfUsePage.text.pWithoutCause_p_0}</strong>
                        )}
                      </p>
                    </div>
                    <div>
                      <span>d.</span>{' '}
                      <p>
                        {strings.formatString(
                          strings.termOfUsePage.text.pWithoutCause_q,
                          <strong>{strings.termOfUsePage.text.pWithoutCause_q_0}</strong>
                        )}
                      </p>
                    </div>
                    <div className={popup.popup__force}>
                      <p>
                        {strings.formatString(
                          strings.termOfUsePage.text.pWithoutCause_forceMaj,
                          <strong>{strings.termOfUsePage.text.pWithoutCause_forceMaj_0}</strong>
                        )}
                      </p>
                    </div>
                    <div>
                      <span>e.</span>{' '}
                      <p>
                        {strings.formatString(
                          strings.termOfUsePage.text.pWithoutCause_r,
                          <strong>{strings.termOfUsePage.text.pWithoutCause_r_0}</strong>
                        )}
                      </p>
                    </div>
                    <div>
                      <span>f.</span>{' '}
                      <p>
                        {strings.formatString(
                          strings.termOfUsePage.text.pWithoutCause_s,
                          <strong>{strings.termOfUsePage.text.pWithoutCause_s_0}</strong>
                        )}
                      </p>
                    </div>
                  </div>
                  <div>
                    <p>
                      <strong>{strings.termOfUsePage.text.pContactsTitle}</strong>
                    </p>
                    <p>{strings.termOfUsePage.text.pHaveAnyQuestions}</p>
                    <p>
                      <a href="mailto: hello@staq.io">{strings.termOfUsePage.text.pMail}</a>
                    </p>
                    <p>{strings.termOfUsePage.text.pTermsUpdatedOn}</p>
                  </div>
                </div>
              </div>
              <div className={popup.popup__check}>
                {keycloak.authenticated ? (
                  <>
                    <Fragment>
                      <ListItem className="terms">
                        <Checkbox
                          name="terms"
                          className="big"
                          tabIndex={-1}
                          checked={agreed}
                          onChange={(e) => {
                            setAgreed(e.target.checked);
                          }}
                          label={strings.termOfUsePage.text.agreed}
                        />
                      </ListItem>
                    </Fragment>
                    <div className={popup.popup__btn_continue}>
                      <Button
                        type="submit"
                        variant="primary"
                        secondaryClassName="popup_primary"
                        onClick={() => {
                          agreeToTerms();
                        }}
                        disabled={!agreed}
                      >
                        {strings.termOfUsePage.buttons.continue}
                      </Button>
                    </div>
                  </>
                ) : (
                  <Fragment />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
